import * as tslib_1 from "tslib";
import React from 'react';
import contains from 'dom-helpers/query/contains';
import matches from 'dom-helpers/query/matches';
import Pop from '../components/Pop';
import PopManager from './PopManager';
var popManger = new PopManager();
/**
 * 弹出内容效果组件
 */
var PopContainer = /** @class */ (function (_super) {
    tslib_1.__extends(PopContainer, _super);
    function PopContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.contentRef = React.createRef();
        _this.onRequestClose = function () {
            if (popManger.top !== _this) {
                return;
            }
            _this.close();
        };
        _this.state = {
            openPopContent: _this.props.open,
        };
        _this.openIsControlled = typeof _this.props.open === 'boolean';
        _this.onLayoutClick =
            props.popAction === 'hover' ? undefined : _this.onLayoutClick.bind(_this);
        _this.onMouseEnter =
            props.popAction === 'hover' ? _this.onMouseEnter.bind(_this) : undefined;
        _this.onMouseLeave =
            props.popAction === 'hover' ? _this.onMouseLeave.bind(_this) : undefined;
        _this.onWindowMouseUp = _this.onWindowMouseUp.bind(_this);
        _this.onStartPop = _this.onStartPop.bind(_this);
        _this.onLayoutRef = _this.onLayoutRef.bind(_this);
        _this.close = _this.close.bind(_this);
        _this.open = _this.open.bind(_this);
        return _this;
    }
    PopContainer.prototype.componentDidMount = function () {
        window.addEventListener('mouseup', this.onWindowMouseUp, true);
        if (this.props.popRef) {
            this.props.popRef(this);
        }
    };
    PopContainer.prototype.componentWillUnmount = function () {
        window.removeEventListener('mouseup', this.onWindowMouseUp, true);
        if (this.props.popRef) {
            this.props.popRef(undefined);
        }
        popManger.destroy(this);
    };
    PopContainer.prototype.onWindowMouseUp = function (event) {
        if (!this.state.openPopContent &&
            (!this.openIsControlled || !this.props.open)) {
            return;
        }
        var target = event.target;
        if (!this.contentRef.current ||
            !this.popLayout ||
            contains(this.contentRef.current, target) ||
            contains(this.popLayout, target) ||
            matches(target, '.sinoui-inner-pop *')) {
            return;
        }
        this.onRequestClose();
    };
    PopContainer.prototype.open = function () {
        if (this.openIsControlled) {
            return;
        }
        if (this.state.openPopContent) {
            return;
        }
        this.setState({
            openPopContent: true,
        });
        popManger.open(this);
        if (this.props.onOpen) {
            this.props.onOpen();
        }
    };
    // tslint:disable-next-line:no-any
    PopContainer.prototype.close = function (event) {
        if (this.openIsControlled) {
            if (this.props.onRequestClose) {
                this.props.onRequestClose();
            }
            return;
        }
        if (!this.state.openPopContent) {
            return;
        }
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        this.setState({
            openPopContent: false,
        });
        popManger.close(this);
    };
    /**
     * 监听pop容器的点击事件
     */
    PopContainer.prototype.onLayoutClick = function (event) {
        if (this.openIsControlled || this.props.disabled) {
            return;
        }
        if (!this.props.propagation) {
            event.stopPropagation();
        }
        this.open();
    };
    PopContainer.prototype.onMouseEnter = function (event) {
        var _this = this;
        if (this.openIsControlled) {
            return;
        }
        clearTimeout(this.closeTimer);
        if (this.props.hoverdelay) {
            this.closeTimer = setTimeout(function () {
                _this.open();
            }, this.props.hoverdelay === true ? 500 : this.props.hoverdelay);
        }
        else {
            this.open();
        }
    };
    PopContainer.prototype.onMouseLeave = function (event) {
        var _this = this;
        if (this.props.hoverdelay) {
            clearTimeout(this.closeTimer);
        }
        if (this.props.popAction !== 'hover') {
            this.closeTimer = setTimeout(function () {
                _this.onRequestClose();
                // tslint:disable-next-line:no-any
            }, 200);
        }
    };
    PopContainer.prototype.onLayoutRef = function (popLayout) {
        this.popLayout = popLayout;
        var innerRef = this.props.innerRef;
        if (innerRef) {
            innerRef(popLayout);
        }
    };
    /**
     * 获取pop元素的相对位置
     *
     * @private
     * @param {HTMLElement} dom pop元素
     * @returns
     * @memberof PopContainer
     */
    PopContainer.prototype.getOffset = function (dom) {
        var _a = this.props, verticalOriginPosition = _a.verticalOriginPosition, horizontalOriginPosition = _a.horizontalOriginPosition;
        var _b = dom.getBoundingClientRect(), width = _b.width, height = _b.height;
        var x = horizontalOriginPosition === 'right'
            ? -width
            : horizontalOriginPosition === 'center'
                ? -width / 2
                : 0;
        var y = verticalOriginPosition === 'bottom'
            ? -height
            : verticalOriginPosition === 'center'
                ? -height / 2
                : 0;
        return { x: x, y: y };
    };
    /**
     * 调整位置
     *
     * @private
     */
    PopContainer.prototype.rePos = function (pos, popDom) {
        var x = pos.x;
        var y = pos.y;
        var clientWidth = document.documentElement.clientWidth;
        var clientHeight = document.documentElement.clientHeight;
        var _a = popDom.getBoundingClientRect(), popWidth = _a.width, popHeight = _a.height;
        // 超出底部时
        if (y + popHeight > clientHeight - 8) {
            y = clientHeight - popHeight - 8;
        }
        // 超出顶部
        if (y <= 8) {
            y = 8;
        }
        // 超出左侧
        if (x < 8) {
            x = 8;
        }
        // 超出右侧
        if (x + popWidth > clientWidth) {
            x = clientWidth - popWidth - 8;
        }
        return { x: x, y: y };
    };
    /**
     * 开始弹窗的事件监听器
     *
     * @private
     * @param {HTMLElement} dom 被点击弹窗的框
     * @memberof PopContainer
     */
    PopContainer.prototype.onStartPop = function (dom) {
        var _a = this.props, horizontalPosition = _a.horizontalPosition, verticalPosition = _a.verticalPosition;
        var _b = this.popLayout.getBoundingClientRect(), width = _b.width, height = _b.height, left = _b.left, top = _b.top;
        var x = horizontalPosition === 'center'
            ? width / 2
            : horizontalPosition === 'right'
                ? width
                : 0;
        var y = verticalPosition === 'center'
            ? height / 2
            : verticalPosition === 'top'
                ? 0
                : height;
        var offset = this.getOffset(dom);
        var pos = {
            x: x + offset.x,
            y: y + offset.y,
        };
        if (this.props.useModal) {
            pos = {
                x: pos.x + left,
                y: pos.y + top,
            };
        }
        if (this.props.autoRePos) {
            pos = this.rePos(pos, dom);
        }
        dom.style.transform = "translate(" + pos.x + "px, " + pos.y + "px)";
    };
    PopContainer.prototype.render = function () {
        return (React.createElement(Pop, tslib_1.__assign({}, this.props, { onClick: this.onLayoutClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, onStartPop: this.onStartPop, open: this.openIsControlled ? this.props.open : this.state.openPopContent, close: this.onRequestClose, innerRef: this.onLayoutRef, contentRef: this.contentRef })));
    };
    PopContainer.defaultProps = {
        autoRePos: true,
        useModal: true,
        verticalOriginPosition: 'top',
        horizontalOriginPosition: 'left',
        verticalPosition: 'bottom',
        horizontalPosition: 'left',
    };
    return PopContainer;
}(React.Component));
export default PopContainer;
//# sourceMappingURL=PopContainer.js.map